import forOwn from 'lodash/forOwn';
import isEmpty from 'lodash/isEmpty';
import toNumber from 'lodash/toNumber';
import startsWith from 'lodash/startsWith';
import isNil from 'lodash/isNil';

import { PRICE_FROM, PRICE_TO, TAGS, TERMS } from 'constants/session-search';

export const mapSearchQuery = (query) => {
  const NUMERIC_FIELDS = ['page', 'pageSize', `search[${PRICE_FROM}]`, `search[${PRICE_TO}]`];

  if (query instanceof URLSearchParams) {
    const mappedQuery = Object.fromEntries(query);

    forOwn(mappedQuery, (value, key) => {
      if (NUMERIC_FIELDS.includes(key) && !isNaN(value)) {
        mappedQuery[key] = toNumber(value);
      }

      if (key.includes(TAGS)) {
        mappedQuery[key] = value.split(',');
      }
    });

    if (!mappedQuery[`search[${TERMS}]`]) {
      mappedQuery[`search[${TERMS}]`] = '';
    }

    return mappedQuery;
  }

  const { search, ...rest } = query;

  forOwn(search, (value, key) => {
    if (key === TERMS) {
      // URLSearchParams writes a null as the word "null", which the API then searches for.
      rest[`search[${key}]`] = value ?? '';
    } else if (([PRICE_FROM, PRICE_TO].includes(key) && !isNaN(value)) || !isEmpty(value)) {
      rest[`search[${key}]`] = value;
    }
  });

  return rest;
};

export const getImageExtension = (url) => url.split(/[#?]/)[0].split('.').pop().trim();

export const getImageTypeAndQualityToBlob = (url) => {
  const extension = getImageExtension(url);

  switch (extension) {
    case 'png':
      return { type: 'image/png', quality: 1.0 };
    case 'gif':
      return { type: 'image/gif', quality: 1.0 };
    case 'webp':
      return { type: 'image/webp', quality: 0.85 };
    default:
      return { type: 'image/jpeg', quality: 0.92 };
  }
};

export const isAdminPath = () => startsWith(window.location.pathname, '/admin');

export const generatePath = (path, params = {}) => {
  let resultPath = path;

  forOwn(params, (value, key) => {
    if (!isNil(value) && value !== '') {
      resultPath = resultPath.replace(new RegExp(`:${key}(\\([^)]+\\))?\\??`, 'g'), String(value));
    }
  });

  resultPath = resultPath.replace(/\/:[a-zA-Z_][a-zA-Z0-9_]*\?/g, '');
  resultPath = resultPath.replace(/^:[a-zA-Z_][a-zA-Z0-9_]*\?/g, '');

  resultPath = resultPath.replace(/\/+/g, '/');

  if (isEmpty(resultPath)) {
    return '/';
  }

  return resultPath;
};
